import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserPathFindingDemo from 'src/games/demos/phaserPathFindingDemo/Main';

interface PathFindingDemoProps extends PageProps<{}> {
}

class PathFindingDemo extends React.Component<PathFindingDemoProps> {
    constructor(props: PathFindingDemoProps) {
        super(props);
        bindAllOfThis(this, PathFindingDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserPathFindingDemo />
        </div>);
    }
}

export default PathFindingDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/PathFindingDemo.tsx